/**
 * The largest `count` to send to `listProximityAssets` in a single request.
 *
 * This is a server constraint, not a per-surface product choice: the API
 * returns an Internal Server Error on a large `count` regardless of how many
 * assets actually match. 1200 keeps a wide margin, and it is the count every
 * whole-set asset fetch in the app has always used.
 *
 * A collection may hold more assets than this (an account's
 * `max_asset_set_locations` can be far higher), so callers that fetch a whole
 * set should expect to be truncated at this ceiling and say so where a user
 * would otherwise be misled.
 */
export const maxProximityAssetCount = 1200;
